import { useDispatch } from 'react-redux';

// Design System
import { SecondaryButton } from 'jl-design-system/elements/button/Button';

// Types
import { AppDispatch } from 'types/RootState.types';
import { CollectionPointProps } from 'types/CollectionPoint.types';
import { ClickAndCollectSearchListViewProps } from './ClickAndCollectSearchListView.types';

// Config
import routes from '@constants/routeConstants';
import { openMoreDetailsModal } from '@redux/actions/click-and-collect/clickAndCollectActions';

// Components
import ClickAndCollectCollectionPoint from '@components/click-and-collect-collection-point';

const ClickAndCollectSearchListView = ({
  collectionPointSearchResults = [],
  countdownVisible = false,
  defaultSliceAmount = 10,
  disabled = false,
  getCollectionPointDatesApiCallActive = false,
  selectCollectionPoint,
  selectedCollectionPoint,
  selectingCollectionPointId,
  shopsToShow = 10,
  showMoreShops = () => {},
  storeToPromote = {},
}: ClickAndCollectSearchListViewProps) => {
  const dispatch: AppDispatch = useDispatch();

  const showMoreClickHandler = () => showMoreShops(shopsToShow + defaultSliceAmount);
  const moreDetailsClickHandler = (collectionPoint: CollectionPointProps) => {
    const { id } = selectedCollectionPoint || collectionPoint;

    dispatch(openMoreDetailsModal({ id, route: routes.CLICK_AND_COLLECT }));
  };

  const hideBorderForStoreInList = (otherStoreIndex: number) => {
    let hideBorder = false;
    if (storeToPromote) {
      const { shouldRemoveFromList, index } = storeToPromote;
      const safeIndex = index ?? -1;

      hideBorder = shouldRemoveFromList ? otherStoreIndex === 0 : otherStoreIndex === safeIndex - 1;
    }

    return hideBorder;
  };

  const { shouldRemoveFromList, index, store } = storeToPromote;

  const displayList = shouldRemoveFromList
    ? collectionPointSearchResults.filter((_, i) => i !== index)
    : collectionPointSearchResults;

  const slicedResults = displayList.slice(0, shopsToShow);
  const elementToFocusOn = shopsToShow - defaultSliceAmount;
  const disableShowMoreButton = slicedResults.length >= displayList.length;

  const showMoreButton = !disableShowMoreButton && (
    <SecondaryButton data-testid="click-collect-show-more-button" disabled={disabled} onClick={showMoreClickHandler}>
      Show more shops
    </SecondaryButton>
  );

  return (
    <>
      <ul className="pl-0">
        {store && (
          <ClickAndCollectCollectionPoint
            collectionPoint={store}
            disabled={disabled}
            getCollectionPointDatesApiCallActive={getCollectionPointDatesApiCallActive}
            onMoreDetailsClick={() => moreDetailsClickHandler(store)}
            promoted
            selectCollectionPoint={selectCollectionPoint}
            selectingCollectionPointId={selectingCollectionPointId}
          />
        )}

        {slicedResults.map((item, index) => (
          <ClickAndCollectCollectionPoint
            key={item.id}
            autoFocus={elementToFocusOn > 0 && elementToFocusOn === index}
            collectionPoint={item}
            disabled={disabled}
            getCollectionPointDatesApiCallActive={getCollectionPointDatesApiCallActive}
            hideBorder={(countdownVisible && index === 0) || hideBorderForStoreInList(index)}
            onMoreDetailsClick={() => moreDetailsClickHandler(item)}
            selectCollectionPoint={selectCollectionPoint}
            selectingCollectionPointId={selectingCollectionPointId}
          />
        ))}
      </ul>

      {showMoreButton}
    </>
  );
};

export default ClickAndCollectSearchListView;
